import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./Home.css";
import { AiOutlineProduct } from "react-icons/ai";
import { LuGalleryHorizontalEnd, LuWarehouse } from "react-icons/lu";
import { FiPackage } from "react-icons/fi";

function Home() {
    const navigate = useNavigate();

    const handleLogout = () => {
        sessionStorage.removeItem('isAuthenticated');
        navigate('/');
    };

    return (
        <div id="container">
            <div id="nav_bar">
                <div id="logo_container">
                    <img id="logo_title" src={"logo-header.png"} alt="Logo" />
                </div>
                <div id="title">
                    <p>Home</p>
                </div>
                <div id="logout_button">
                    <button id="logout" onClick={handleLogout}>Logout</button>
                </div>
            </div>

            <div id="card_container">
                {/* Card Visualizza */}
                <div className="card">
                    <div className="header_card">
                        <div className="icon_card"><LuGalleryHorizontalEnd /></div>
                        <div className="title_card"><h2>Visualizza</h2></div>
                    </div>
                    <div className="desc_card">
                        <p>Mostra i quadri presenti nel magazzino sempre aggiornati, mostrando tutte le infomrazioni</p>
                    </div>
                    <div className="button_card">
                        <button
                            className="btn-visualizza"
                            onClick={() => navigate('/visualizza')}
                        >
                            Visualizza
                        </button>
                    </div>
                </div>

                {/* Card Aggiungi */}
                <div className="card">
                    <div className="header_card">
                        <div className="icon_card"><AiOutlineProduct /></div>
                        <div className="title_card"><h2>Aggiungi</h2></div>
                    </div>
                    <div className="desc_card">
                        <p>Inserisci o aggiorni tutti i quadri e tutte le loro informazioni quando necessario</p>
                    </div>
                    <div className="button_card">
                        <button
                            className="btn-visualizza"
                            onClick={() => navigate('/aggiungi')}
                        >
                            Visualizza
                        </button>
                    </div>
                </div>

                {/* Card Controllo */}
                <div className="card">
                    <div className="header_card">
                        <div className="icon_card"><LuWarehouse /></div>
                        <div className="title_card"><h2>Controllo</h2></div>
                    </div>
                    <div className="desc_card">
                        <p>Controlla le quantità disponibili dei quadri e tutte le vendite che sono state fatte durante le fiere</p>
                    </div>
                    <div className="button_card">
                        <button
                            className="btn-visualizza"
                            onClick={() => navigate('/gestisci')}
                        >
                            Visualizza
                        </button>
                    </div>
                </div>

                {/* Card Creazione */}
                <div className="card">
                    <div className="header_card">
                        <div className="icon_card"><FiPackage /></div>
                        <div className="title_card"><h2>Creazione</h2></div>
                    </div>
                    <div className="desc_card">
                        <p>Crea e modifica in modo da gestire al meglio le fiere dove è presente Ideahome</p>
                    </div>
                    <div className="button_card">
                        <button
                            className="btn-visualizza"
                            onClick={() => navigate('/crea')}
                        >
                            Visualizza
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;